const routes = [
    {
        path: "/proforma/invoices",
        component: () => import("../page/Index"),
        meta: {
            isAuthenticated: true,
            permission:"proformainvoice_index"
        }
    }
];

export default routes;
